var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeezer = function SvgDeezer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 11.096H50.162v8.075H64v-8.075Z",
    fill: "#29AB70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 22.342H50.162v8.075H64v-8.075Z",
    fill: "url(#Deezer_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33.583H50.162v8.075H64v-8.075Z",
    fill: "url(#Deezer_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.838 44.829H0v8.075h13.838V44.83Z",
    fill: "url(#Deezer_svg__c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.556 44.829H16.72v8.075h13.837V44.83Z",
    fill: "url(#Deezer_svg__d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.28 44.829H33.444v8.075h13.838V44.83Z",
    fill: "url(#Deezer_svg__e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64 44.829H50.162v8.075H64V44.83Z",
    fill: "url(#Deezer_svg__f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.28 33.583H33.444v8.075h13.838v-8.075Z",
    fill: "url(#Deezer_svg__g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.556 33.583H16.72v8.075h13.837v-8.075Z",
    fill: "url(#Deezer_svg__h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.556 22.342H16.72v8.075h13.837v-8.075Z",
    fill: "url(#Deezer_svg__i)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Deezer_svg__a",
    x1: 57.981,
    y1: 31.476,
    x2: 56.181,
    y2: 21.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C8C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#298E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#129C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#05A475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A770"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Deezer_svg__b",
    x1: 49.956,
    y1: 41.251,
    x2: 64.206,
    y2: 33.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2839BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#148CB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Deezer_svg__c",
    x1: 0,
    y1: 48.864,
    x2: 13.838,
    y2: 48.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Deezer_svg__d",
    x1: 16.719,
    y1: 48.864,
    x2: 30.556,
    y2: 48.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D12F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Deezer_svg__e",
    x1: 33.443,
    y1: 48.864,
    x2: 47.281,
    y2: 48.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4197C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#472EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Deezer_svg__f",
    x1: 50.162,
    y1: 48.864,
    x2: 64,
    y2: 48.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2839BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3072B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Deezer_svg__g",
    x1: 32.897,
    y1: 39.802,
    x2: 47.821,
    y2: 35.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4197C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373AAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Deezer_svg__h",
    x1: 16.234,
    y1: 34.926,
    x2: 31.047,
    y2: 40.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D12F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Deezer_svg__i",
    x1: 17.889,
    y1: 21.071,
    x2: 29.386,
    y2: 31.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED743B"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeezer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "8a2860a3a120e618b004c45d094646b1.svg";